export const getIsDateInPDTInPast = (testedDate?: string): boolean => {
  if (!testedDate) return false

  // Convert current time to PDT
  const now = new Date()
  const pdtOffset = -7 * 60 * 60 * 1000 // PDT is UTC-7
  const currentPDT = new Date(now.getTime() + pdtOffset)

  const dateTime = new Date(testedDate)

  return currentPDT > dateTime
}

export type CalendarProvider = 'google' | 'outlook' | 'apple'

export const generateCalendarUrlForEvent = (
  event: {
    startDate: string
    endDate?: string
    title: string
    locationShort: string
  },
  provider: CalendarProvider,
) => {
  const startDate = new Date(event.startDate)
  const endDate = event.endDate
    ? new Date(event.endDate)
    : new Date(event.startDate)

  // Format dates for calendar URLs
  const formatDateForUrl = (date: Date) => {
    return date.toISOString().replace(/-|:|\.\d+/g, '')
  }

  const title = encodeURIComponent(event.title)
  const location = encodeURIComponent(event.locationShort)

  switch (provider) {
    case 'google':
      return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${title}&dates=${formatDateForUrl(
        startDate,
      )}/${formatDateForUrl(endDate)}&location=${location}`
    case 'outlook':
      return `https://outlook.live.com/calendar/0/deeplink/compose?path=/calendar/action/compose&rru=addevent&subject=${title}&startdt=${startDate.toISOString()}&enddt=${endDate.toISOString()}&location=${location}&`
    case 'apple':
      return `data:text/calendar;charset=utf8,BEGIN:VCALENDAR%0AVERSION:2.0%0ABEGIN:VEVENT%0ADTSTART:${formatDateForUrl(
        startDate,
      )}%0ADTEND:${formatDateForUrl(
        endDate,
      )}%0ASUMMARY:${title}%0ALOCATION:${location}%0AEND:VEVENT%0AEND:VCALENDAR`
    default:
      return ''
  }
}
